import React from 'react'
import PropTypes from 'prop-types'
import { Container } from 'reactstrap'
import PatriotActDisclosure from './PatriotActDisclosure'
import { FooterLinks } from 'shared/components'
import RefinanceDisclosure from './RefinanceDisclosure'
const CSHFooter = ({
  copyrightYear,
  footerLinks,
  showStandardArticles
}) => {
  let counter = 1

  return (
    <footer role="contentinfo" id="footer" className="mt-5">
      <Container>
        <FooterLinks footerLinks={footerLinks} />

        <h3
          data-test="text.online-disclosures-heading"
          id="online-disclosures-header"
        >
          Online Disclosures
        </h3>

        <PatriotActDisclosure />

        <div data-test="etc.online-disclosures" id="footer-content">
          <p>
            Cash Store is not a direct lender in Texas, where instead it
            acts in the capacity as a Credit Services Organization.
          </p>

          <p>
            {counter++}. Approval depends upon meeting legal, regulatory and
            underwriting requirements. Originated loans can be funded in as
            little as 30 minutes to a Visa debit card. Funding times may vary
            based on the consumer debit card bank. Funding to a MasterCard
            may be subject to restrictions. Funding by ACH may occur as soon
            as the same day. Retail applications completed online can obtain a
            "Conditional Approval" at any time. Retail locations can provide
            funds, upon approval, during regular business hours. Check
            <a
              title="Cash Store"
              href="https://locations.cashstore.com"
              target="_blank"
              rel="noopener noreferrer"
              className="pseudolink"
            >
              https://locations.cashstore.com
            </a>{' '}
            for detail on store information.
            All times and dates are based on Eastern Time (ET). Online amounts
            may vary by state. Please see the website for details. All products
            and service options are subject to change without notice. Cash
            Store may report customer loan information to one or more credit
            reporting agencies. Late payments, missed payments and other events
            of default may be reflected in customer credit reports. See
            cashstore.com for details. The lender may, at their discretion,
            verify application information by using national databases that
            may provide information from one or more national credit bureaus,
            and the lender may take that into consideration in the approval
            process.
          </p>

          <p>
            {counter++}. Actual loan amount and terms will vary based on final
            evaluation of income and credit qualifications. Payment amounts
            vary by rate.
          </p>

          <RefinanceDisclosure
            counter={counter}
            isRefinance={!showStandardArticles}
          />

          <p>
            Cash Store and third parties verify application information by
            using national databases that may provide information from one
            or more national credit bureaus, and Cash Store or third parties
            may take that into consideration in the approval process.
          </p>

          <p>
            We do not report credit in Texas.
          </p>

          <p>
            Products or services offered to customers may vary based on customer
            eligibility and applicable state or federal law. All available
            products subject to applicable lender&apos;s terms and conditions.
            Actual loan amounts vary. See State Center for specific information
            and requirements.
          </p>

          <p>
            ** Cash Store doesn&apos;t charge you for using text messages (SMS)
            for two-factor authentication. However, your mobile provider's
            standard rates for sending and receiving messages may apply.
          </p>

          <p>
            &dagger; By providing your telephone number, including any mobile
            number, you consent that we may call you at these numbers for
            servicing and marketing telephone calls.
          </p>

          <p>
            Cash Store currently operates online and in store in: Idaho, Texas,
            and Wisconsin.
          </p>

          <span data-test="text.copyright">
            &copy; {copyrightYear} Cash Store. All rights reserved.
            <address>PO Box 36454, Cincinnati, OH 45236</address>
          </span>
        </div>
      </Container>
    </footer>
  )
}

CSHFooter.displayName = 'AlliedFooter'
CSHFooter.propTypes = {
  copyrightYear: PropTypes.number.isRequired,
  footerLinks: PropTypes.array,
  showStandardArticles: PropTypes.bool
}

export default CSHFooter
